/**
 * ONE source of truth for whether the "Connect Google Business Profile" flow is
 * offered to offices.
 *
 * Google has not granted this project Business Profile API access yet (application
 * 6-8517000041217, filed 2026-08-12; the previous one was rejected 2026-08-04 on
 * requestor eligibility). Until it lands, clicking Connect hits Google's own
 * "Access blocked" wall — our OAuth app is still in the Testing audience — or, past
 * that, a 429 with quota 0. So every entry point shows an honest pending state
 * instead of a button that cannot succeed.
 *
 * WHY THIS LIVES IN ITS OWN MODULE: it started as a local constant inside
 * ReviewsSettings.vue, which gated the Settings tab and nothing else — the Reviews
 * OVERVIEW tab kept two live Connect buttons in its empty states, on the default
 * landing tab, where an office was more likely to find them than the one that was
 * gated. A release flag that lives inside one component only ever gates that
 * component. Import this everywhere; do not re-declare it.
 *
 * Deliberately NOT stage-conditional. An earlier version kept the live button on dev
 * via NODE_ENV, which meant the pending panel could never render on dev and would
 * have been seen for the first time on prod, in front of the pilot office —
 * backwards for a change whose whole point is that first impression. Every stage
 * renders the same thing, so what you approve on dev is what ships.
 *
 * FLIP TO true when the grant is approved (Cloud Console quota 0 -> 300). That
 * restores the live Connect button on every surface, on every stage, at once.
 */
export const GOOGLE_CONNECT_RELEASED = false;

export default GOOGLE_CONNECT_RELEASED;
